import { DashboardJobsStatus, DashboardJobsType } from '~/domain/DashboardJobs';
import { FilterStatusEnum } from '~/utils/Enum';
import { ShiftOverviewTab } from '../ShiftOverviewTab';

export const OpenTab = ({ jobType }: { jobType: DashboardJobsType }) => (
  <ShiftOverviewTab
    jobType={jobType}
    listStatus={DashboardJobsStatus.OPEN}
    cardStatus="open"
    dataCy="open-shifts-grid"
    emptyType={FilterStatusEnum.OPEN}
    cardClickTo={(item) => `/dashboard/job/${item.id}`}
    editTo={(item) => `/dashboard/job/${item.id}/edit`}
    invite={{ shiftStatus: 'Open', trackingSource: 'Open Shift' }}
    canCancel
  />
);
